export default __webpack_public_path__ + "static/media/783.4ad420e0.jpg";